import hashStorage from 'shared/utils/storeUtils/hashStore'
import { create } from 'zustand'
import { createJSONStorage, persist } from 'zustand/middleware'
import { NoteTypeReasonOption } from '../ListingNotes.types'

export type NotesFilterType = {
    users: string[]
    noteTypes: NoteTypeReasonOption[]
    dateFrom: string | null
    dateTo: string | null
    setNoteTypes: (noteTypes: NoteTypeReasonOption[]) => void
    setUsers: (users: string[]) => void
    setDateFrom: (dateFrom: string | null) => void
    setDateTo: (dateTo: string | null) => void
    setNotesFilters: (filters: Partial<NotesFilterType>) => void
    resetFilters: () => void
}

export const DEFAULT_FILTERS = {
    users: [],
    noteTypes: [],
    dateFrom: null,
    dateTo: null,
}

const store = persist<NotesFilterType>(
    (set) => ({
        ...DEFAULT_FILTERS,
        setNotesFilters: (filters: Partial<NotesFilterType>) =>
            set((state: Partial<NotesFilterType>) => ({
                ...state,
                ...filters,
            })),
        setNoteTypes: (noteTypes: NoteTypeReasonOption[]) => {
            set({ noteTypes })
        },
        setUsers: (users: string[]) => set({ users }),
        setDateFrom: (dateFrom: string | null) => set({ dateFrom }),
        setDateTo: (dateTo: string | null) => set({ dateTo }),
        resetFilters: () => set(DEFAULT_FILTERS),
    }),
    {
        name: 'note-filters',
        storage: createJSONStorage<NotesFilterType>(() => hashStorage),
    }
)

export const useNoteFiltersStore = create(store)
